import ItemStatus from '@/Enums/ItemStatus.enum';
import type { ICampaignManagementLineItem } from '@/Interfaces/CampaignManagement/LineItem.interface';
import { getLineItemActivationConditions } from '@/helpers/campaignManagement/lineItemStatus.helpers';
import LineItemActivationButton from '@/pages/CampaignManagement/components/LineItemActivationButton';
import { useAppDispatch } from '@/store/hooks';
import { updateLineItem } from '@/store/slices/campaignManagementSlice';
import { memo } from 'react';
import { toast } from 'react-toastify';

interface IProps {
  activeLineItem?: ICampaignManagementLineItem;
  setLoading: (flag: boolean) => void;
  loading: boolean;
}

const LineItemStatusChangeButton = memo(({ activeLineItem, loading, setLoading }: IProps) => {
  const { status } = activeLineItem ?? { status: ItemStatus.INACTIVE };
  const dispatch = useAppDispatch();

  const onClickActivate = async () => {
    try {
      const newStatus = status === ItemStatus.ACTIVE ? ItemStatus.INACTIVE : ItemStatus.ACTIVE;
      setLoading(true);
      if (activeLineItem?.id) {
        await dispatch(
          //@ts-expect-error js reducer
          updateLineItem({ id: activeLineItem.id, campaignId: activeLineItem.campaign_id, status: newStatus }),
        ).unwrap();
        toast.success('Line Item status updated');
      }
    } catch (error) {
      toast.error(`Failed to update Line Item status: ${(error as Error)?.message ?? ''}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LineItemActivationButton
      isActive={status === ItemStatus.ACTIVE}
      conditions={getLineItemActivationConditions(activeLineItem)}
      onToggle={onClickActivate}
      disabled={loading}
    />
  );
});

export default LineItemStatusChangeButton;
